// extracted by mini-css-extract-plugin
export default {"badgeContainer":"Changelog_badgeContainer__YhIIb","changelogEntry":"Changelog_changelogEntry__gy2WL"};